import {
    Component, inject
} from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: "mgd-app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    imports: [RouterOutlet]
})
export class AppComponent {
    title = "app";

    constructor() {
        const matIconRegistry = inject(MatIconRegistry);

        matIconRegistry.setDefaultFontSetClass("material-symbols-outlined");
    }
}
